import { useCallback, useRef } from 'react';
import { useMsal } from '@azure/msal-react';
import { setAuthToken } from '../services/apiService';

const API_SCOPE = 'api://7e9ba977-33b0-4e9c-ae75-55f65da317bd/access';

/**
 * Returns a function that refreshes the API bearer token (silently, from the MSAL cache) before a
 * request. Tokens expire after an hour, and the editor stays open for long sessions.
 *
 * The returned function keeps the same identity for the component's lifetime (it reads the current
 * MSAL instance and account through a ref), so effects that depend on it do not re-run, and refetch
 * or reset state, whenever MSAL republishes its account list.
 */
export const useAuthToken = () => {
  const { instance, accounts } = useMsal();
  const latest = useRef({ instance, accounts });
  latest.current = { instance, accounts };
  return useCallback(async () => {
    const { instance: msal, accounts: signedIn } = latest.current;
    const response = await msal.acquireTokenSilent({ scopes: [API_SCOPE], account: signedIn[0] });
    setAuthToken(response.accessToken);
  }, []);
};
